module.exports = __webpack_public_path__ + "img/coulissante.8205024.svg";